import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ActiveFilters from './ActiveFilters';
import FilterPriceRange from './FilterPriceRange';

import DesktopFilterItem from './presentionalComponents/DesktopFilterItem';
import Filter from './Filter';

// import './FilterContainerMain.scss';
// import './FilterGeneral.scss';
import UISettings from '../../settings/UISettings';
import {
  getActiveListingPage,
  getNumberOfActiveFiltersOnActiveListingPage
} from '../../reduck/selectors';
import ConnectedLocationSearchBlock from '../TopLevelContainers/ConnectedLocationSearchBlock';

import {
  FilterContainer,
  FilterContainerLoader,
  FilterContainerHeader,
  ActiveFiltersTitle,
  FilterContainerBody
} from './styled';

function FiltersContainerDesktop({
  pendingProductsRequest,
  filtersIdsTriggeredProductsRequest,
  numberOfActiveFilters,
  filtersFromSearchLabs,
  renderingOnServer,
  isLocationSearchEnabled
}) {
  function renderFilterItem(filterItem) {
    return (
      <DesktopFilterItem
        openByDefault={
          filterItem.openedByDefault ||
          filterItem.values.findIndex((value) => value.selected) !== -1
        }
        label={filterItem.label === 'segment_id' ? 'Browse by category' : filterItem.label}
        key={filterItem.id}
      >
        <Filter
          loading={
            pendingProductsRequest && filtersIdsTriggeredProductsRequest.includes(filterItem.id)
          }
          onlyOneFilterSelectedMode={filterItem.id === 'rounded_score'}
          filterItemData={filterItem}
        >
          {filterItem.id === 'delivery' && !renderingOnServer && isLocationSearchEnabled ? (
            <ConnectedLocationSearchBlock name={'filter block'} />
          ) : null}
        </Filter>
      </DesktopFilterItem>
    );
  }

  function renderPriceFilter() {
    return (
      <DesktopFilterItem openByDefault label={'Price'}>
        <FilterPriceRange
          loading={pendingProductsRequest}
          loadingPriceFilter={
            pendingProductsRequest && filtersIdsTriggeredProductsRequest.includes('price')
          }
          useInteractivePlaceholderForInputs={pendingProductsRequest}
        />
      </DesktopFilterItem>
    );
  }

  function renderSegmentFilterFirst(filter) {
    return filter.id === 'segment_id' ? renderFilterItem(filter) : null;
  }

  function checkForSegmentFilters(checkedFilters) {
    if (checkedFilters[0].id === 'segment_id') {
      return checkedFilters.filter((filter) => filter.id !== 'segment_id');
    }
    return checkedFilters;
  }

  return (
    <FilterContainer className={'dc-filter-container'} data-is-loading={pendingProductsRequest}>
      {pendingProductsRequest && (
        <FilterContainerLoader className={'dc-filter-container__loader'} />
      )}

      {numberOfActiveFilters !== 0 && (
        <ActiveFilters filtersFromSearchLabs={filtersFromSearchLabs} displayResetButton />
      )}
      <FilterContainerHeader className={'dc-filter-container__header'}>
        <ActiveFiltersTitle className={'dc-active-filters__title'}>Filter by:</ActiveFiltersTitle>
      </FilterContainerHeader>
      <FilterContainerBody className={'dc-filter-container__body'}>
        {filtersFromSearchLabs &&
          filtersFromSearchLabs.length > 0 &&
          renderSegmentFilterFirst(filtersFromSearchLabs[0])}
        {renderPriceFilter()}
        {filtersFromSearchLabs && filtersFromSearchLabs.length > 0
          ? checkForSegmentFilters(filtersFromSearchLabs).map((filter) => renderFilterItem(filter))
          : null}
      </FilterContainerBody>
    </FilterContainer>
  );
}

FiltersContainerDesktop.displayName = 'FiltersContainerDesktop';

FiltersContainerDesktop.propTypes = {
  numberOfActiveFilters: PropTypes.number.isRequired,
  filtersFromSearchLabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      openedByDefault: PropTypes.bool,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired,
          count: PropTypes.string
        })
      ).isRequired
    })
  ),
  pendingProductsRequest: PropTypes.bool,
  filtersIdsTriggeredProductsRequest: PropTypes.arrayOf(PropTypes.string),
  renderingOnServer: PropTypes.bool,
  isLocationSearchEnabled: PropTypes.bool
};

FiltersContainerDesktop.defaultProps = {
  filtersFromSearchLabs: undefined,
  pendingProductsRequest: false,
  filtersIdsTriggeredProductsRequest: [],
  renderingOnServer: false,
  isLocationSearchEnabled: false
};

const mapStateToProps = (state) => ({
  numberOfActiveFilters: getNumberOfActiveFiltersOnActiveListingPage(state),
  filtersFromSearchLabs: getActiveListingPage(state).filtersFromSearchLabs,
  pendingProductsRequest: state.listingPage.commonData.xhrStatus.pendingProductsRequest,
  filtersIdsTriggeredProductsRequest:
    state.listingPage.commonData.xhrStatus.filtersIdsTriggeredProductsRequest,
  renderingOnServer: !state.listingPage.browser,
  isLocationSearchEnabled:
    UISettings.get('component.mcd.postcodechecker.enabled_for_this_segment') !== false &&
    UISettings.get('component.mcd.postcodechecker.enabled') !== false
});

export default connect(mapStateToProps)(FiltersContainerDesktop);
